import { createPlanNameMatcher } from './utils/PlanMetaHelper';
import { IPlanContent } from '../typings/planContent.types';
import {
  byoBatteryAddon,
  defaultEstimatesDialog,
  businessDualKeyDetailsAddons,
  businessElectricityKeyDetailsAddons,
  ongoingBenefitPeriodKeyDetails,
} from './common/planDefaults';
import { createSolarInfoContent } from './common/solarInfoContent';

const PLAN_TONE = 'promoteB';

export const originBusinessSolarBoostVariableContent: IPlanContent = {
  test: createPlanNameMatcher(['Origin Business Solar Boost Variable']),
  content: {
    rateDiscountText: {
      defaultState: {
        defaultFuel: 'Rates variable on an ongoing benefit period',
      },
    },
    keyFeatures: {
      defaultState: {
        defaultFuel: ['No lock in contract or exit fees'],
      },
    },
    keyDetails: {
      defaultState: {
        defaultFuel: ongoingBenefitPeriodKeyDetails,
      },
    },
    keyDetailsAddons: {
      defaultState: {
        defaultFuel: [],
        dual: [...businessDualKeyDetailsAddons, byoBatteryAddon],
        electricity: [...businessElectricityKeyDetailsAddons, byoBatteryAddon],
      },
    },
    uiOptions: {
      defaultState: {
        defaultFuel: {
          planColor: {
            text: {
              styleGuide: 'purple',
              odsCore: PLAN_TONE,
            },
            promobox: {
              styleGuide: 'purple',
              odsCore: PLAN_TONE,
            },
            bannerText: {
              styleGuide: 'white',
              odsCore: 'white',
            },
          },
          imageUrl:
            'https://res.cloudinary.com/originenergy/image/upload/v1728624900/spot-illustrations/spot_Origin-Solar-Boost.svg',
          imageForFuelType: {
            electricity:
              'https://www.originenergy.com.au/cdn/images/originenergy/image/upload/CP/plans/cp_origin-solar-boost.svg',
            dual: 'https://www.originenergy.com.au/cdn/images/originenergy/image/upload/CP/plans/cp_origin-solar-boost.svg',
          },
        },
      },
    },
    tagLine: {
      defaultState: {
        defaultFuel: 'A boosted variable feed-in tariff on an ongoing energy plan.',
      },
    },
    termsAndConditionsUrl: {
      defaultState: {
        defaultFuel: '/terms-and-conditions/',
      },
    },
    estimatesDialog: defaultEstimatesDialog({ customerType: 'business' }),
    solarInfo: {
      defaultState: {
        defaultFuel: {
          title: 'Origin Business Solar Boost Variable',
          content: createSolarInfoContent(
            'Origin Business Solar Boost Variable (with tiered feed-in tariff)',
            true
          ),
        },
      },
    },
  },
};
